// extracted by mini-css-extract-plugin
export default {"container":"LandingAdmin_container__dsp0f","link":"LandingAdmin_link__ymkVq"};